import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.css']
})
export class FaqPageComponent implements OnInit {

  pageName = "Help / FAQ";

  constructor() { }

  ngOnInit() {
  	$('#initialise-page').trigger('click');
  }

}
